var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-baseline"},[_c('div',{staticClass:"flex-1 px-4"},[_c('RouterLink',{attrs:{"to":{
        name: 'accounts.pipelines.pipelineUuid',
        params: {
          ..._vm.$route.params,
          pipelineUuid: _vm.pipeline.id,
        },
      }}},[_vm._v(" "+_vm._s(_vm.pipeline.name)+" ")])],1),_c('div',{staticClass:"px-4"},[(_vm.$membershipHasPermissionTo('edit pipelines,delete pipelines'))?_c('VDropdown',{attrs:{"right":""},scopedSlots:_vm._u([{key:"button",fn:function(dropdownProps){return [_c('button',{staticClass:"btn btn-ghost px-3",on:{"click":dropdownProps.open}},[_c('FontAwesomeIcon',{attrs:{"icon":"ellipsis-v","fixed-width":""}})],1)]}},{key:"default",fn:function(dropdownProps){return [_c('VDropdownMenu',[(_vm.$membershipHasPermissionTo('edit pipelines'))?_c('a',{class:[
              'block',
              'px-4',
              'py-2',
              'hover:bg-gray-200',
              'transition-color',
              'transition-fast',
              'text-right',
            ],attrs:{"role":"button"},on:{"click":function($event){dropdownProps.close(() => _vm.$emit('pipeline-edit', _vm.pipeline))}}},[_vm._v("Edit")]):_vm._e(),(_vm.$membershipHasPermissionTo('delete pipelines'))?_c('a',{class:[
              'block',
              'px-4',
              'py-2',
              'hover:bg-gray-200',
              'transition-color',
              'transition-fast',
              'text-right',
            ],attrs:{"role":"button"},on:{"click":function($event){dropdownProps.close(() => _vm.$emit('pipeline-delete', _vm.pipeline))}}},[_vm._v("Remove")]):_vm._e()])]}}],null,false,1457879463)}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }